export default __webpack_public_path__ + "static/media/serie-4.3d37863b.png";